import { useCallback, useEffect, useRef, useState } from "react";
import { fetchInfoScreenDisplay } from "@/lib/infoScreenApi";
import type { InfoScreenDisplayPayload } from "@/types/infoScreen";

/** Sicherheits-Polling falls SSE getrennt ist */
const POLL_MS = 30_000;

export function useInfoScreenDisplay(displayCode: string, { enabled }: { enabled: boolean }) {
  const [data, setData] = useState<InfoScreenDisplayPayload | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const revisionRef = useRef<string | null>(null);

  const load = useCallback(async () => {
    if (!enabled) return;
    try {
      const payload = await fetchInfoScreenDisplay(displayCode);
      if (revisionRef.current !== payload.revision) {
        revisionRef.current = payload.revision;
        setData(payload);
      } else {
        setData((prev) => (prev ? { ...prev, ...payload } : payload));
      }
      setError(null);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Laden fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  }, [displayCode, enabled]);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }
    void load();
    const timer = window.setInterval(() => {
      void load();
    }, POLL_MS);
    return () => window.clearInterval(timer);
  }, [enabled, load]);

  return { data, loading, error, reload: load };
}
